import React, { useContext, useEffect, useState } from 'react';
import LeftNav from './LeftNav';
import { fetchDataFromApi } from '../utils/api';
import { Context } from '../context/contextApi';
import { useParams } from 'react-router-dom';
import SearchVideoCard from './SearchVideoCard';

const SearchResults = () => {

  const [results, setResults] = useState([]);
  const {setLoading} = useContext(Context);
  const {searchQuery} = useParams();

  useEffect(() => {
    document.getElementById('root').classList.remove("custom-h");
    getSearchResults();
  }, [searchQuery]);

  const getSearchResults = () => {
    setLoading(true);
    fetchDataFromApi(`search/?q=${searchQuery}`)
    .then((res) => {
      // console.log(res?.contents)
      setResults(res?.contents);
      setLoading(false)
    }).catch((err) => console.log(err));
  }

  return (
    <div className="flex flex-row h-[calc(100%-56px)]">
      <LeftNav />
      <div className='overflow-y-scroll md:w-[calc(100%-240px)] w-[100%] p-4 bg-black'>
        {
          results && results.filter((video) => (video?.type === "video")).map((item, i) => {
            return <SearchVideoCard item={item} key={i}/>
          })
        }
      </div>
    </div>
  )
}

export default SearchResults 
